import { renderToString } from "react-dom/server";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { MemoryRouter } from "react-router-dom";
import type { PrerenderArguments, PrerenderResult } from "vite-prerender-plugin";
import App from "../App";
import { AuthProvider } from "../lib/auth-provider";
import { getSiteUrl } from "./metadata";
import { buildSeoHeadElements } from "./headElements";
import { resolveSeoMetaForPath } from "./routes";

function buildHeadElements(route: string, siteUrl: string) {
	const meta = resolveSeoMetaForPath(route, siteUrl);
	return new Set(buildSeoHeadElements(meta, siteUrl));
}

export function prerender(data: PrerenderArguments): PrerenderResult {
	const route = data.url || "/";
	const siteUrl = getSiteUrl(import.meta.env.VITE_SITE_URL || "https://www.textformatter.pro");
	const meta = resolveSeoMetaForPath(route, siteUrl);
	const queryClient = new QueryClient();
	const html = renderToString(
		<MemoryRouter initialEntries={[route]}>
			<QueryClientProvider client={queryClient}>
				<AuthProvider>
					<App />
				</AuthProvider>
			</QueryClientProvider>
		</MemoryRouter>,
	);

	return {
		html,
		head: {
			lang: "en",
			title: meta.title,
			elements: buildHeadElements(route, siteUrl),
		},
	};
}
